<template>
    <span class="scroll-top">
        <PageTitle imagem="pop2.png" :main="$t('gatilhos-de-ocorrencia')" sub="" />
        <div class="main-trigger">
            <b-overlay id="overlay-background" class="overlay-config" :show="loading" rounded="sm">
                <SelectIndicator :configuration="configuration" :reset="resetFormSelect"
                    @resetFormTriggers="resetFormTriggers = $event" @selectIndicator="selectIndicator = $event"
                    @loadConfiguration="configurationIndicator = $event" @selectProcess="triggerSet.setProcess($event)"
                    @selectProduct="triggerSet.setProduct($event)" @selectEquipment="triggerSet.setEquipment($event)" />

                <ConfigIndicator :selectIndicator="configurationIndicator" :dicIndicator="configuration.dicIndicator"
                    :indicatorConfiguration="configuration.indicatorConfiguration" :reset="resetFormSelect" />

                <TriggerLimitValue :triggerInfo="triggerInfo" :reset="resetFormTriggers"
                    :triggerSelected="triggerIsSelected" />

                <TriggerReliability :triggerInfo="triggerInfo" :reset="resetFormTriggers"
                    :triggerSelected="triggerIsSelected" />

                <TriggerAverageValue :triggerInfo="triggerInfo" :reset="resetFormTriggers"
                    :triggerSelected="triggerIsSelected" />
            </b-overlay>

            <hr>
            <b-row class="groupBtn">
                <img src="@/assets/cancel.png" style="margin-left: 30px;" :title="$t('limpar-formulario')" alt="limpar"
                    @click="cleanFields" />
                <img src="@/assets/atualizar.png" style="margin-left: 30px;" :title="$t('recarregar-dados')"
                    :alt="$t('recarregar-dados')" @click="loadConfigurations" />
                <img src="@/assets/salvar.png" alt="salvar" style="margin-left: 30px;" :title="$t('salvar')"
                    @click="() => saveDataInDatabase(false)" />
            </b-row>

            <b-overlay id="overlay-background2" :show="loadTable" rounded="sm">
                <TriggerList :deviationList="tableSet.collection" @saveTrigger="saveTrigger($event)"
                    @deleteTrigger="askDeleteTriggerTaleLine($event)" />
            </b-overlay>

        </div>

        <b-modal id="showHelpe" size="md" hide-footer :title="$t('alerta')" :no-close-on-backdrop="true">
            <MessageBox :info="helpeMessage" modelname="showHelpe" />
        </b-modal>

        <b-modal id="setResponsible" size="lg" hide-footer :title="$t('cadastro-de-envolvidos')"
            :no-close-on-backdrop="true">
            <TriggerResponsible :trigger="triggerSelected" />
        </b-modal>

        <b-modal id="AskDeleteTrigger" size="md" hide-footer :title="$t('alerta')" :no-close-on-backdrop="true">
            <MessageBox :question="deleteMessage" v-bind:action="deleteTrigger" modelname="AskDeleteTrigger" />
        </b-modal>

        <b-modal id="AskDuplicateTrigger" size="md" hide-footer :title="$t('alerta')" :no-close-on-backdrop="true">
            <MessageBox :question="askDuplicateTriggerMessage" @cancelAction="() =>
                this.$bvModal.hide('AskDuplicateTrigger')" v-bind:action="() => this.removeDuplicatedTrigger(true)"
                modelname="AskDuplicateTrigger" />
        </b-modal>
    </span>
</template>

<script>
import axios from 'axios';
import PageTitle from "../template/PageTitle";
import SelectIndicator from "./template/SelectIndicator.vue"
import ConfigIndicator from "./template/ConfigIndicator.vue"
import TriggerLimitValue from "./template/TriggerValueLimit.vue"
import TriggerReliability from "./template/TriggerReliability.vue"
import TriggerAverageValue from "./template/TriggerAverageValue.vue"
import TriggerResponsible from "./template/TriggerResponsible.vue"
import TriggerList from "./template/TriggerList.vue"
import TriggerInfo from "./tools/triggerInfo"
import TriggerSet from "./model/TriggerSet"
import TriggerTableSet from "./model/TriggerTableSet"
import Trigger from "./model/Trigger"
import MessageBox from "../template/MessageBoxModal.vue";
import { urlMainAPI, defaultSuccess, ParseNumber, showError } from '../../global';
import { mapState } from 'vuex';
import MediatorTrigger from './tools/MediatorTrigger';

export default {
    name: "TriggerManagement",
    components: {
        PageTitle,
        MessageBox,
        TriggerList,
        SelectIndicator,
        ConfigIndicator,
        TriggerLimitValue,
        TriggerReliability,
        TriggerAverageValue,
        TriggerResponsible
    },

    computed: mapState(["isOnlineReady"]),
    provide() {
        return {
            showInfo: this.openInfo,
            showResponsibles: this.openConfigResponsible,
        };
    },
    data() {
        return {
            deviations: [],
            loading: false,
            dicIndicator: [],
            listKeys: [],
            configuration: {},
            configurationIndicator: {},
            selectIndicator: null,
            helpeMessage: "",
            deleteMessage: "",
            triggerSet: {},
            trigger: new Trigger(),
            tableSet: { collection: [] },
            loadTable: false,
            resetFormSelect: 0,
            resetFormTriggers: 0,
            triggerListSelected: {},
            triggerIsSelected: this.triggerSet ? this.triggerSet.loadIndicators : null,
            triggerSelected: {},
            eneableSave: null,
            triggersDuplicateToDelete: [],
            askDuplicateTriggerMessage: "",
            isEditing: false,
            filteredEquipments: [],
        }
    },

    watch: {
        async selectIndicator(value) {
            if (value != null) {
                let ind = this.configuration.dicIndicator[value]
                this.triggerSet.setNewTriggers();
                setTimeout(() => { this.triggerSet.setIndicator(ind) }, 100)
            }
        },
        async resetFormTriggers() {
            this.selectIndicator = null;
        }
    },

    methods: {
        setInitialTrigger() {
            this.triggerInfo = new TriggerInfo(this.configuration.triggersInfo)
            this.triggerSet = new TriggerSet(this.triggerInfo)
        },

        openInfo(info) {
            this.helpeMessage = info;
            this.$bvModal.show("showHelpe");
        },

        openConfigResponsible(triggercode) {
            this.triggerSelected = this.triggerSet.triggers.find(t => t.triggercode == triggercode)
            if (this.triggerSelected && this.triggerSelected.active)
                this.$bvModal.show("setResponsible");
        },

        cleanFields() {
            this.resetFormSelect++
            this.configurationIndicator = ""
            this.resetFormTriggers++
            this.triggerSet.setNewTriggers();
            defaultSuccess(this.$t('formulario-restaurado'))
        },

        async loadConfigurations() {
            this.loadTable = true;
            this.loading = true;
            await this.getDataFromDatabase()
            this.updataTableList()
            this.setInitialTrigger()
        },

        async saveDataInDatabase(userDeleting) {
            let triggers = this.tryGetTriggerToSave();
            if (!triggers.length) return;

            let alreadyAdded = this.triggerSet.databaseTriggers.filter(item =>
                item.indicatorId === triggers[0].indicatorId &&
                item.triggerId === triggers[0].triggerId
            );

            // Verifica se estamos criando um novo gatilho com um processo diferente para o mesmo indicador e gatilho
            if (alreadyAdded.length > 0 && userDeleting === false) {
                // Filtra para ver se existe algum já existente com processo diferente
                const duplicateWithDifferentProcess = alreadyAdded.some(item => item.processId !== triggers[0].processId);

                if (duplicateWithDifferentProcess) {
                    this.triggersDuplicateToDelete = alreadyAdded;
                    this.askDuplicateTriggerMessage = `${this.$t('o-indicador')} [${triggers[0].indicatorName}] ${this.$t('tem-configurado-o-gatilho')} [${triggers[0].triggercode}] ${this.$t('em-outro-processo-deseja-remove-los')}`;
                    this.$bvModal.show("AskDuplicateTrigger");
                    return;
                }
            }

            // Salva o gatilho diretamente se passou pelas validações
            if (await this.saveTriggers(triggers)) {
                defaultSuccess(this.$t('dados-do-gatilho-salvo-com-sucesso'));
                this.cleanFields();
                await this.loadConfigurations();
            }

            // Reseta a flag de edição
            if (this.isEditing === true) this.isEditing = false;
        },

        async removeDuplicatedTrigger(isDeleting) {
            if (isDeleting) {
                await axios.post(`${urlMainAPI}/deletetriggers`, this.triggersDuplicateToDelete)
                    .then(res => {
                        if (res.status == 200)
                            defaultSuccess(res.data)
                    })
                    .catch(console.error)
            }
            await this.saveDataInDatabase(isDeleting);
        },

        async saveTriggers(triggers) {
        console.log("saveTriggers ~ triggers:", triggers)


            
            let success = false;
            await axios.post(`${urlMainAPI}/savetriggers/${false}`, triggers)
                .then(res => {
                    if (res.status == 200)
                        success = true
                })
                .catch(console.error)
            return success
        },

        tryGetTriggerToSave() {
            let triggers = []
            try {
                triggers = this.triggerSet.getTriggersToSave()

                triggers.forEach(trigger => {
                    trigger.criticalRange = triggers[0].criticalRange;
                    trigger.operationalRange = triggers[0].operationalRange;
                    trigger.reliabilityCritical = triggers[0].reliabilityCritical;
                    trigger.reliabilityThreshold = triggers[0].reliabilityThreshold;
                    trigger.target = triggers[0].target;
                });
            }
            catch (e) {
                showError(e)
                return []
            }
            if (triggers.length == 0) showError(this.$t('e-necessario-selecionar-um-gatilho-para-salvar'));
            return triggers
        },
        async getDataFromDatabase() {
            this.loading = true;
            await axios.get(`${urlMainAPI}/getconfigurationsfortrigger`)
                .then(res => {
                    if (res.status == 200) {
                        this.cleanFields()
                        this.triggerInfo = new TriggerInfo(res.data.triggersInfo)
                        this.configuration = res.data
                    }
                })
                .catch(console.warn)
            this.loading = false;
        },

        async updataTableList() {
            this.loadTable = true;
            await axios.get(`${urlMainAPI}/gettriggers/${false}`)
                .then(res => {
                    if (res.status == 200)
                        this.tableSet = new TriggerTableSet(res.data)
                    this.triggerSet.setCollection(res.data)
                })
                .catch(console.warn)
            this.loadTable = false;
        },

        askDeleteTriggerTaleLine(row) {
            this.triggerListSelected = row
            this.deleteMessage = `Deseja apagar o indicador [${row.indicator}] dos gatilhos ?`
            this.$bvModal.show("AskDeleteTrigger");
        },

        async deleteTrigger() {
            this.loadTable = true;
            await axios.get(`${urlMainAPI}/deletetrigger/${this.triggerListSelected.key}`)
                .then(async res => {
                    if (res.status == 200) {
                        if (!this.isEditing)
                            defaultSuccess(res.data)
                        await this.updataTableList();
                    }
                })
                .catch(console.warn)
            this.loadTable = false;
        },

        async saveTrigger(row) {
            this.loadTable = true;
            let triggers = await this.triggerSet.getListTriggerTableLine(row)
            triggers = triggers.map(t => ({ ...t, target: ParseNumber(t.target) }))
            if (await this.saveTriggers(triggers)) {
                defaultSuccess(this.$t('gatilhos-atualizados'))
            }
            this.loadTable = false;

        },

        filterEquipmentsByProcess(processId) {
            if (!processId) {
                this.filteredEquipments = [];
                return;
            }
            
            // Filtra os equipamentos pelo processId
            this.filteredEquipments = this.configuration.equipments.filter(equipment => 
                equipment.processId === processId
            );
        },

        // Método para ser chamado quando um processo é selecionado
        handleProcessSelected(processId) {
            this.filterEquipmentsByProcess(processId);
        },
    },

    beforeMount() {
        this.triggerInfo = new TriggerInfo()
    },

    async created() {
        this.setInitialTrigger();
        await this.loadConfigurations()
        MediatorTrigger.notify(this, "initTriggerManager")
    },
}
</script>

<style>
.element-overlap>div>input {
    margin: 0 8px;
}

.trigger-checkBox>label,
.trigger-checkBox>label,
.element-overlap>div>label {
    padding: 2.5px 4px 0 4px;
}

.trigger-checkBox>.custom-control-label {
    cursor: pointer;
    background-color: white;
}

.scroll-top {
    height: inherit;
    overflow: auto;
}
</style>

<style scoped src="./style.css"></style>